import { useRouter } from "next/router"

import { useCurrentUserQuery } from "../graphql/public-generated-rq"

export const useOrgSlugBridge = () => {
  const router = useRouter()
  const user = useCurrentUserQuery()
  if (typeof router.query.orgSlug === "string") {
    return router.query.orgSlug
  } else {
    return user.data?.currentUser.org?.slug ?? ""
  }
}
